module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Histórico da cobrança"},"en-US":{"title":"Charges history"}}')
  delete Component.options._Ctor
}
